export const AppointmentState = {
  UPCOMING: 0,
  ONGOING: 1,
  PAST: 2
}